import { Label } from "../ui/label";
import { Checkbox } from "../ui/checkbox";
import { RadioGroup, RadioGroupItem } from "../ui/radio-group";

export function SectionHeader({ id, step, title, subtitle }) {
  return (
    <div id={id} className="section-anchor mb-4 pb-4 border-b border-slate-100">
      <p className="text-xs uppercase tracking-[0.2em] text-slate-500 mb-1">Step {step}</p>
      <h2 className="text-xl font-semibold tracking-tight text-[#0D1B2A]">{title}</h2>
      {subtitle && <p className="text-sm text-slate-500 mt-1">{subtitle}</p>}
    </div>
  );
}

export function Field({ label, required, children }) {
  return (
    <div className="space-y-1.5">
      <Label className="text-xs uppercase tracking-wider text-slate-500">
        {label}{required && <span className="text-[#DC2626] ml-1">*</span>}
      </Label>
      {children}
    </div>
  );
}

export function CheckRow({ id, checked, onCheckedChange, label, badge, meta }) {
  return (
    <label
      htmlFor={id}
      className={`check-row flex items-start gap-3 p-3 border border-slate-200 rounded-md cursor-pointer ${checked ? "selected" : ""}`}
    >
      <Checkbox id={id} checked={checked} onCheckedChange={onCheckedChange} data-testid={`check-${id}`} />
      <div className="flex-1">
        <div className="flex items-center gap-2 flex-wrap">
          <span className="text-sm font-medium text-[#0D1B2A]">{label}</span>
          {badge}
        </div>
        {meta && <span className="text-xs text-slate-500 block mt-0.5">{meta}</span>}
      </div>
    </label>
  );
}

export function CertBadge({ cert, modules }) {
  return (
    <span className="flex items-center gap-1">
      <span className={`text-[10px] font-semibold px-2 py-0.5 rounded ${cert ? "bg-[#0D1B2A] text-white" : "bg-[#1A7F6E] text-white"}`}>
        {cert ? "CERT" : "VERIF"}
      </span>
      {modules?.map((m) => (
        <span key={m} className="text-[10px] font-semibold px-1.5 py-0.5 rounded bg-slate-200 text-slate-700">{m}</span>
      ))}
    </span>
  );
}

export function RadioRow({ value, onChange, name, noUnsure, thirdLabel, thirdValue }) {
  return (
    <RadioGroup value={value} onValueChange={onChange} className="flex flex-wrap gap-4 mt-1">
      <div className="flex items-center gap-2">
        <RadioGroupItem value="yes" id={`${name}-yes`} data-testid={`${name}-yes`} />
        <Label htmlFor={`${name}-yes`} className="text-sm">Yes</Label>
      </div>
      <div className="flex items-center gap-2">
        <RadioGroupItem value="no" id={`${name}-no`} data-testid={`${name}-no`} />
        <Label htmlFor={`${name}-no`} className="text-sm">No</Label>
      </div>
      {!noUnsure && (
        <div className="flex items-center gap-2">
          <RadioGroupItem value={thirdValue || "unsure"} id={`${name}-third`} data-testid={`${name}-third`} />
          <Label htmlFor={`${name}-third`} className="text-sm">{thirdLabel || "Unsure"}</Label>
        </div>
      )}
    </RadioGroup>
  );
}
